import { SET_ASSETS_VIEW_SIZE } from './types';

export const setAssetsGridItemSize = itemSize => ( {
	type: SET_ASSETS_VIEW_SIZE,
	payload: itemSize
} );
